<template>
    <div class="galery-selector" v-loading="loader">
        <el-tabs v-model="tabActive">
            <el-tab-pane label="Actuel" name="list">
                <div class="row mb-3" v-if="user.can('edit product images')">
                    <div class="col-lg-12">
                        <el-input placeholder="URL de l'image" type="url" v-model="file_url">
                            <template slot="prepend">Http://</template>
                            <el-button slot="append" v-if="url_uploader" icon="el-icon-loading"></el-button>
                            <template v-if="url_upload_end">
                                <el-button slot="append" v-if="url_upload_success" icon="el-icon-check"></el-button>
                                <el-button slot="append" v-if="!url_upload_success" icon="el-icon-warning"></el-button>
                            </template>
                            <el-button slot="append" icon="el-icon-search" class="success" @click="handleChangeFileUrl(file_url)"></el-button>
                        </el-input>
                        <el-alert class="m-2" v-if="url_upload_error" :title="url_upload_error" type="error" show-icon></el-alert>
                        <small class="text-muted">Insérer l'URL d'une image au format jpg/png</small>
                    </div>
                </div>

                <div class="row row-cards">
                    <div class="col-sm-4 col-lg-3" v-if="user.can('edit product images')">
                        <div class="card image-ctn p-3">
                            <el-upload ref="uploadProductImage" accept="image/jpg,image/jpeg,image/png,image/webp" :data="{product_id: product.id, variation_id: (variation.id) ? variation.id : '' }" :before-upload="checkFileUpload" :headers="headersUpload" class="upload-image-product" drag action="/medias" :on-success="uploadSuccess" :file-list="fileList" multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">Déposer les fichiers ici ou
                                    <em>cliquez pour téléverser</em>
                                </div>
                                <div class="el-upload__tip" slot="tip">jpg/png avec une taille inférieur à 8Mo</div>
                            </el-upload>
                        </div>
                    </div>

                    <div class="col-sm-4 col-lg-3" v-loading="image.loader" v-for="(image, index) in objectImages" :key="index">
                        <div class="card image-ctn p-3">
                            <a href="#" @click.prevent="openLightbox(image)" class="mb-3">
                                <img :src=" '/ic/medium/' + image.path + '?v=' + version" :alt="image.filename" class="rounded img-product-list">
                            </a>
                            <div class="d-flex align-items-center px-2">
                                <div>
                                    <div class="filename">{{ image.filename }}</div>
                                    <small class="d-block text-muted">{{ image.created_at_human }}</small>
                                    <el-switch @change="saveDefaultImage" name="default_image" v-model="default_image" :active-value=" image.id "></el-switch>
                                </div>

                            </div>
                            <div class="d-flex image-tags align-items-center">
                                <a href="#" v-for="(tag, indexTag) in image.tags" :key="indexTag" class="badge badge-secondary  mx-1">{{ tag.name }}</a>
                            </div>
                            <div class="d-flex text-center justify-content-around w-100 actions-image">
                                <el-button-group v-if="user.can('edit product images')">
                                    <el-button @click='rotate(image, 90)' size="mini" plain><i class='fe fe-rotate-ccw'></i></el-button>
                                    <el-button @click='rotate(image, -90)' size="mini" plain><i class='fe fe-rotate-cw'></i></el-button>
                                </el-button-group>
                                <div class="input-order-ctn">
                                    <el-input
                                        v-model="image.order"
                                        size="small">
                                    </el-input>
                                </div>
                                <el-button-group v-if="user.can('edit product images')">
                                    <el-button @click="disociateImage(image)" size="mini" type="warning" plain>Disocier</el-button>
                                    <el-button @click="removeImage(image)" size="mini" type="danger" plain>Supprimer</el-button>
                                </el-button-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <el-button v-loading="loaderReorga" plain type="warning" size="mini" @click="orderChangeImage()">Réorganiser</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>

        <el-dialog class="lightbox-galery" @closed="cleanLigtbox" :visible.sync="lightbox.display" fullscreen append-to-body>
            <div slog="title">
                <h4>{{ lightbox.image.filename }}</h4>
                <span v-for="(tag, indexTag) in lightbox.image.tags" :key="indexTag" class="badge badge-secondary mx-1">{{ tag.name }}</span>
            </div>
            <div class="lightox-galery-ctn my-3" v-loading="lightbox.loader" v-if="lightbox.image.path">
                <img @load="lightbox.loader = false" :src=" '/ic/original/' + lightbox.image.path" :alt="lightbox.image.filename">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="lightbox.display = false">Fermer</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import methods from './methods';
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
    },
    data() {
        return {
            _default_image: null,
            init: false,
            file_url: null,
            url_uploader: false,
            url_upload_success: false,
            url_upload_end: false,
            url_upload_error: null,
            loadingTags: false,
            loaderReorga: false,
            headersUpload: {
                'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
            },
            tabActive: 'list',
            loader: false,
            fileList: [],
            images: [],
            tags: [],
            pagination: {
                total: 0,
                from: 0,
                to: 0
            },
            params: {
                page: 1,
                orderBy: 'created_at',
                order: 'desc',
                tags: []
            },
            lightbox: {
                display: false,
                image: {},
                loader: true
            },
            options: [],
            version: 1,
        };
    },
    props: {
        value: {
            required: () => {
                return this.selectable;
            },
            default: () => {
                return [];
            }
        },
        product: {
            required: true
        },
        variation: {
            default() {
                return {};
            }
        },
        selectable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        default_image: {
            get() {
                return this.product.media_id
            },
            set(value) {
                if( value ) {
                    this.product.media_id = value
                }
            }
        },
        selected: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        hasVariation() {
            return this.variation.id ? true : false;
        },
        disociateImageUrl() {
            return this.hasVariation
                ? '/products/' +
                      this.product.id +
                      '/variations/' +
                      this.variation.id
                : '/products/' + this.product.id;
        },
        associateImageUrl() {
            return this.hasVariation
                ? '/products/' +
                      this.product.id +
                      '/variations/' +
                      this.variation.id
                : '/products/' + this.product.id;
        },
        objectImages: {
            get() {
                return this.hasVariation
                ? this.variation.images
                : this.product.images;
            },
            set(value) {
                if( this.hasVariation ) {
                    this.variation.images = value
                } else {
                    this.product.images = value
                }
            }

        },
        currentObject: {
            get() {
                return this.hasVariation ? this.variation : this.product;
            },
            set(value) {
                if (this.hasVariation) {
                    this.variation = value;
                } else {
                    this.product = value;
                }
            }
        },
        user() {
            return this.$store.getters['app/user'];
        }
    },
    mounted() {
        this.init = true;
        this.loader = false;
        /*
        this.fetch()
            .then(r => {
                this.images = r.data.data;
                this.pagination = r.data.meta;
                this.default_image = this.product.media_id;
            })
            .catch(() => {})
            .then(() => {
                this.loader = false;
            });
        */
    },
    methods
};
</script>
<style lang="scss">
.galery-selector {
    .el-upload-dragger {
        width: auto;
        height: 180px;
        border: none;
    }
    .pagination-ctn {
        width: 100%;
    }
    .image-ctn {
        &.selected {
            border: 1px solid #007bff;
        }
    }
    .img-product-list {
        width: 100%;
    }
    .tags-selector {
        .el-select {
            width: 100%;
        }
        width: 300px;
    }
    .image-tags {
        margin-bottom: 30px;
        .badge {
            text-overflow: ellipsis;
            max-width: 90px;
            overflow: hidden;
        }
    }
    .actions-image {
        position: absolute;
        bottom: 0;
        right: 0;
        button {
            &:last-child {
                border-top-right-radius: 0;
            }
            &:first-child {
                border-bottom-left-radius: 0;
            }
        }
    }
    .filename {
        text-overflow: ellipsis;
        max-width: 178px;
        overflow: hidden;
        margin-bottom: 5px;
    }
}
.lightbox-galery {
    .el-dialog__body {
        height: 89vh;
        text-align: center;
        .lightox-galery-ctn {
            height: 77vh;
            img {
                border: 1px solid #3c3c3c57;
            }
        }
        img {
            height: 100%;
            object-fit: contain;
        }
    }
}
.input-order-ctn {
    width: 48px;
    margin-right: 10px;
    .el-input--small .el-input__inner {
        height: 24px;
        line-height: 24px;
    }
}
</style>
